import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BrandLogo from "../../components/BrandLogo/BrandLogo";
import { IoArrowBackOutline } from "react-icons/io5";
import { CgLogOut } from "react-icons/cg";
import "./InspectionShell.css";

/**
 * AutoTrade Port shell for inspection screens.
 * Use className "pi-inspection-page--app" for mobile-app chrome.
 */
export default function InspectionShell({
  children,
  badge = "Inspection",
  variant = "dark",
  showFooter = true,
  className = "",
  mainClassName = "",
  onBack,
  onLogout,
  title,
  bottomNav = null,
}) {
  const isCamera = className.includes("pi-inspection-page--camera");
  const isApp = className.includes("pi-inspection-page--app");
  const year = new Date().getFullYear();

  useEffect(() => {
    if (isCamera) return undefined;

    const mq = window.matchMedia("(max-width: 899px)");
    const syncLock = () => {
      const lock = mq.matches;
      document.documentElement.classList.toggle("pi-inspection-lock", lock);
      document.body.classList.toggle("pi-inspection-lock", lock);
    };

    syncLock();
    if (mq.addEventListener) mq.addEventListener("change", syncLock);
    else mq.addListener(syncLock);

    return () => {
      document.documentElement.classList.remove("pi-inspection-lock");
      document.body.classList.remove("pi-inspection-lock");
      if (mq.removeEventListener) mq.removeEventListener("change", syncLock);
      else mq.removeListener(syncLock);
    };
  }, [isCamera]);

  return (
    <div className={`pi-inspection-page ${className}`.trim()}>
      <div className="pi-inspection-page__fx" aria-hidden="true">
        <span className="pi-inspection-page__orb pi-inspection-page__orb--a" />
        <span className="pi-inspection-page__orb pi-inspection-page__orb--b" />
        <span className="pi-inspection-page__orb pi-inspection-page__orb--gold" />
        <span className="pi-inspection-page__aurora pi-inspection-page__aurora--a" />
        <span className="pi-inspection-page__aurora pi-inspection-page__aurora--b" />
        <span className="pi-inspection-page__grid" />
        <span className="pi-inspection-page__beam" />
        <span className="pi-inspection-page__mesh" />
        <span className="pi-inspection-page__grain" />
        {!isCamera ? <span className="pi-inspection-page__glow" /> : null}
      </div>

      <div className="pi-inspection-page__content">
        <header className="pi-inspection-header">
          <div className="pi-inspection-header__inner">
            <div className="pi-inspection-header__start">
              {onBack ? (
                <button
                  type="button"
                  className="pi-inspection-header__icon-btn"
                  onClick={onBack}
                  aria-label="Go back"
                >
                  <IoArrowBackOutline size={22} />
                </button>
              ) : null}
              <BrandLogo
                variant={variant}
                compact
                className="pi-inspection-header__logo"
              />
              {title ? (
                <div className="pi-inspection-header__mobile-context">
                  <span className="pi-inspection-header__title pi-inspection-header__title--mobile">
                    {title}
                  </span>
                  {badge ? (
                    <span className="pi-inspection-header__mobile-tag">
                      {badge}
                    </span>
                  ) : null}
                </div>
              ) : null}
              <span className="pi-inspection-header__divider" aria-hidden />
              <div className="pi-inspection-header__product">
                {title ? (
                  <>
                    <span className="pi-inspection-header__product-name">
                      {title}
                    </span>
                    <span className="pi-inspection-header__product-tag">
                      {badge || "Inspection"}
                    </span>
                  </>
                ) : (
                  <>
                    <span className="pi-inspection-header__product-name">
                      {badge || "Inspection"}
                    </span>
                    <span className="pi-inspection-header__product-tag">
                      Staff workspace
                    </span>
                  </>
                )}
              </div>
            </div>
            <div className="pi-inspection-header__end">
              <Link className="pi-inspection-header__client" to="/">
                Home
              </Link>
              {badge && !title ? (
                <span className="pi-inspection-header__badge pi-inspection-header__badge--mobile">
                  {badge}
                </span>
              ) : null}
              {onLogout ? (
                <button
                  type="button"
                  className="pi-inspection-header__logout"
                  onClick={onLogout}
                  aria-label="Log out"
                >
                  <CgLogOut size={20} aria-hidden />
                  <span>Log out</span>
                </button>
              ) : null}
            </div>
          </div>
        </header>
        <main
          className={`pi-inspection-main ${mainClassName}${
            isApp ? " pi-inspection-main--app" : ""
          }`.trim()}
        >
          {children}
        </main>
        {showFooter ? (
          <footer
            className={`pi-inspection-footer${
              bottomNav ? " pi-inspection-footer--with-tabs" : ""
            }`}
          >
            <div className="pi-inspection-footer__inner">
              <div className="pi-inspection-footer__brand">
                <span className="pi-inspection-footer__mark" aria-hidden />
                <div>
                  <strong>AutoTrade Port</strong>
                  <p>Inspection · vehicle condition workspace</p>
                </div>
              </div>
              <div className="pi-inspection-footer__meta">
                <Link className="pi-inspection-footer__client" to="/">
                  Home
                </Link>
                <p className="pi-inspection-footer__copy">
                  © {year} AutoTrade Port. All rights reserved.
                </p>
              </div>
            </div>
          </footer>
        ) : null}
        {bottomNav}
      </div>
    </div>
  );
}
